if (!customElements.get('collection-filters')) {
  customElements.define(
    'collection-filters',
    class CollectionFilters extends HTMLElement {
      constructor() {
        super();

        this.cache = {};

        this.currentFilter = '';

        this.productList = document.getElementById('product-grid');

        if (!this.productList) return;

        this.tabs = this.querySelectorAll('[role="tab"]');
        this.panels = this.querySelectorAll('[role="tabpanel"]');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.tabHandler.bind(this));
        });

        const onHistoryChange = (event) => {
          const searchFilter = event.state ? event.state.filter : false;

          this.renderFilterView(searchFilter);
          this.setFilter(searchFilter);
        };

        window.addEventListener('popstate', onHistoryChange);

        const searchParams = new URLSearchParams(window.location.search);
        const searchFilter = searchParams.get('filter.p.tag');

        // clear-selection button click handler
        //const clearSelectionButton = this.querySelector('.clear-selection');
        //if (clearSelectionButton) {
        //  clearSelectionButton.addEventListener('click', () => {
        //    this.resetTabs();
        //    this.resetPanels();
        //  });
        //}

        if (searchFilter) {
          this.renderFilterView(searchFilter);
        }
      }

      renderFilterView(filter) {
        this.resetTabs();
        this.resetPanels();

        this.tabs.forEach((tab) => {
          if (tab.dataset.isFilter === 'true' && (tab.dataset.key === filter || tab.dataset.encode === filter)) {
            tab.setAttribute('aria-selected', true);

            const panel = tab.closest('[role="tabpanel"]');

            if (panel) {
              panel.hidden = false;

              if (panel.dataset.level != '0') {
                const parentTabId = panel.getAttribute('aria-labelledby');
                const parentTab = this.querySelector(`#${parentTabId}`);

                if (parentTab) {
                  parentTab.setAttribute('aria-selected', true);

                  const parentPanel = parentTab.closest('[role="tabpanel"]');

                  if (parentPanel) {
                    parentPanel.hidden = false;

                    if (parentPanel.dataset.level != '0') {
                      const grandParentTabId = parentPanel.getAttribute('aria-labelledby');
                      const grandParentTab = this.querySelector(`#${grandParentTabId}`);

                      if (grandParentTab) {
                        grandParentTab.setAttribute('aria-selected', true);

                        const grandParentPanel = grandParentTab.closest('[role="tabpanel"]');

                        if (grandParentPanel) {
                          grandParentPanel.hidden = false;
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            tab.setAttribute('aria-selected', false);
          }
        });
      }

      resetTabs() {
        this.tabs.forEach((tab) => {
          tab.setAttribute('aria-selected', false);
        });
      }

      resetPanels() {
        this.panels.forEach((panel) => {
          panel.hidden = true;
        });
      }

      tabHandler(e) {
        const tab = e.target;
        const level = parseInt(tab.dataset.level);

        var filter = tab.dataset.encode;

        if (level == 0) {
          if (tab.getAttribute('aria-selected') === 'true') {
            this.resetTabs();
            this.resetPanels();

            this.setFilter(false);

            return;
          }
        } else if (tab.getAttribute('aria-selected') === 'true') {
          return;
        }

        this.tabs.forEach((tab) => {
          if (parseInt(tab.dataset.level) >= level) {
            tab.setAttribute('aria-selected', false);
          }
        });

        this.panels.forEach((panel) => {
          if (parseInt(panel.dataset.level) > level) {
            panel.hidden = true;
          }
        });

        tab.setAttribute('aria-selected', true);

        if (tab.dataset.isFilter === 'true') {
          this.setFilter(filter);
        } else {
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
          panel.hidden = false;

          // Choose the first option in the tabpanel.
          // This will cause it to drill down if there are more levels.
          const filter = panel.querySelector('[role="tab"]');
          filter.click();
        }
      }

      setFilter(filter) {
        if (this.currentFilter === filter) return;

        this.currentFilter = filter;

        if (this.cache[filter]) {
          this.renderSectionFromCache(filter);
        } else {
          const url = `${window.location.pathname}?section_id=${this.productList.dataset.id}${filter ? `&filter.p.tag=${filter}` : ''}`;
          this.renderSectionFromFetch(url, filter);
        }
      }

      renderSectionFromFetch(url, filter) {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;

            this.cache[filter] = html;

            document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

            document
              .getElementById('ProductGridContainer')
              .querySelectorAll('.scroll-trigger')
              .forEach((element) => {
                element.classList.add('scroll-trigger--cancel');
              });

            if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

            this.updateHistory(filter);
          });
      }

      renderSectionFromCache(filter) {
        const html = this.cache[filter];

        FacetFiltersForm.renderProductGridContainer(html);

        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

        document
          .getElementById('ProductGridContainer')
          .querySelectorAll('.scroll-trigger')
          .forEach((element) => {
            element.classList.add('scroll-trigger--cancel');
          });

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

        this.updateHistory(filter);
      }

      updateHistory(filter) {
        if (filter) {
          window.history.pushState({ filter: filter }, '', `${window.location.pathname}?filter.p.tag=${filter}`);
        } else {
          window.history.pushState({ filter: filter }, '', window.location.pathname);
        }
      }
    }
  );
}
